export default __webpack_public_path__ + "static/media/pdf.596a3eac.svg";